import { IssueReportStatusEnum } from '@/shared/state/api/swagger';

export const actionsMapping: Record<IssueReportStatusEnum, string> = {
	open: 'В работу',
	progress: 'Решить',
	closed: '',
};
